import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#30c0b0',
    fontWeight: 'bold',
    fontSize: '22px',
  },
}));

const HeadingTitleTypography = ({ children, ...props }) => {
  const classes = useStyles();

  return <Typography className={classes.root}>{children}</Typography>;
};

export default HeadingTitleTypography;
